import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeployParams } from 'src/app/deployParams';
import { PageType } from 'src/app/models/enums';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { TicketService } from 'src/app/services/ticket.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';
import { IUserTM } from 'src/app/ticket-manager/models/user/userTM.interface';
import { AffiliateRole } from 'src/app/ticket-manager/models/util/tmEnums';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { TicketManagerUserService } from 'src/app/ticket-manager/services/ticketManagerUser.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ticket-menu-bar',
  templateUrl: './ticket-menu-bar.component.html',
  styleUrls: ['./ticket-menu-bar.component.less']
})
export class TicketMenuBarComponent implements OnInit {

  private subscription: Subscription = new Subscription();
  eventsCountOnTicket = 0;
  isMobileView: boolean;
  public isLive = false;
  viewConfigurations = ViewConfigurations;

  tmUser: IUserTM;
  affiliate: IAffiliate;
  affiliateRoleEnum = AffiliateRole;

  constructor(
    private ticketService: TicketService,
    private utilityService: UtilityService,
    private queryParams: QueryParamsService,
    protected ticketManagerUserService: TicketManagerUserService,
    protected authentificationService: AuthenticationService) {
    this.isMobileView = utilityService.mobileView;
    this.queryParams.pageTypeChanged$.subscribe(pageType => {
      if (pageType === PageType.Live) {
        this.isLive = true;
      } else {
        this.isLive = false;
      }
    });
    this.subscription.add(this.ticketManagerUserService.tmUserChangedSource$.subscribe(() => this.tmUser = ticketManagerUserService.user));
    this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => this.affiliate = this.authentificationService.loggedAffiliate));
  }

  ngOnInit(): void {
    this.tmUser = this.ticketManagerUserService.user;
    this.affiliate = this.authentificationService.loggedAffiliate;
    this.subscription.add(this.ticketService.ticketItemAddedRemoved$.subscribe(x => this.eventsCountOnTicket = Object.keys(this.ticketService.ticketItemGroups).length));
  }

  sendPostMessage(url: string) {
    if (!environment.localDeploy && window.parent) {
      console.log('link post message:', url);
      // window.parent.postMessage({type: ‘REDIRECT’, url: ‘/casino’} , ‘https://mbase.mbet.rs:9000’);
      window.parent.postMessage({ type: 'REDIRECT', url }, environment.postMessageURL);
    }
  }

  openTicket() {
    this.ticketService.openTicket();
  }

  public navigate(live: boolean) {
    const url = window.location.href;
    if (live) {
      window.location.assign(url.replace('prematch', 'live'));
    } else {
      window.location.assign(url.replace('live', 'prematch'));
    }
  }

}
